import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import BrandLogo from "@/components/brand/BrandLogo";
import CTAButton from "@/components/app/CTAButton";
import { Compass } from "lucide-react";

export default function Login() {
    const { setUser } = useAuth();
    const navigate = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true); setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data);
            const to = loc.state?.from?.pathname || "/app";
            navigate(to, { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally { setLoading(false); }
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-md-bg px-4 py-12">
            <div className="w-full max-w-sm">
                <div className="mb-8 flex justify-center"><BrandLogo variant="horizontal" size="md" /></div>
                <div className="rounded-2xl border border-md-border bg-md-surface p-6 sm:p-8">
                    <h1 className="md-h2 text-md-text">Se connecter</h1>
                    <p className="mt-2 text-sm text-md-text-2">
                        Retrouve ta mission et ton aventure de dresseur.
                    </p>
                    <form onSubmit={onSubmit} className="mt-6 space-y-4">
                        <div>
                            <label className="md-overline mb-2 block">Email</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="login-email"
                                className="block w-full rounded-lg border border-md-border bg-md-bg px-3 py-2.5 text-sm text-md-text outline-none focus:border-md-primary"
                            />
                        </div>
                        <div>
                            <label className="md-overline mb-2 block">Mot de passe</label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="login-password"
                                className="block w-full rounded-lg border border-md-border bg-md-bg px-3 py-2.5 text-sm text-md-text outline-none focus:border-md-primary"
                            />
                        </div>
                        {error && (
                            <div className="rounded-lg border border-md-danger/30 bg-md-danger/10 px-3 py-2 text-xs text-md-danger" data-testid="login-error">
                                {error}
                            </div>
                        )}
                        <CTAButton type="submit" size="block" loading={loading} icon={<Compass className="h-4 w-4" />} testId="login-submit">
                            Entrer dans l’aventure
                        </CTAButton>
                    </form>
                    <p className="mt-6 text-center text-sm text-md-text-2">
                        Pas encore de compte ?{" "}
                        <Link to="/register" data-testid="login-link-register" className="font-semibold text-md-text underline-offset-2 hover:underline">
                            Crée-le ici
                        </Link>
                    </p>
                </div>
                <p className="mt-6 text-center text-xs text-md-text-2">
                    Espace admin :{" "}
                    <Link to="/admin/login" className="underline hover:text-md-text">/admin/login</Link>
                </p>
            </div>
        </div>
    );
}
